import * as React from "react";

export function SelectField(
    name,
    options,
    value,
    fieldName,
    errorMsg,
    onChangeHandler,
    disabled?: boolean,
    containerClass?: string,
    labelStyle?: object,
    inputClass?: string,
) {
    const defaultStyle = {
        fontSize: 15,
        color: "#000000",
        fontWeight: 700,
    };
    const defaultInputStyle = {
        borderRadius: ".25rem",
        backgroundColor: "#FFFFFF",
        border: "1px solid #434175",
        height: 47,
    };
    const optionStyle = {
        fontSize: 14,
    };
    return (
        <div style={{marginBottom: 27, textAlign: "center"}}>
            <label
                style={labelStyle ? labelStyle : defaultStyle}
                htmlFor={fieldName}>
                {name}
            </label>
            {errorMsg && (
                <label
                    style={{fontSize: 14}}
                    htmlFor={fieldName}
                    className="label-error">
                    {errorMsg}
                </label>
            )}
            <select
                id={fieldName}
                className={`form-control ${inputClass ? inputClass : ""}`}
                value={value}
                style={inputClass ? {} : defaultInputStyle}
                onChange={(e) => onChangeHandler(fieldName, e.target.value)}
                disabled={disabled ? disabled : false}>
                {options.map((item, index) => {
                    return (
                        <option style={optionStyle} value={item.value} key={index}>
                            {item.name}
                        </option>
                    );
                })}
            </select>
        </div>
    );
}
